import isPropValid from '@emotion/is-prop-valid';

// styled-components v6 no longer auto-filters unknown props before forwarding to DOM elements.
// Wrap the app (and test renderers) in <StyleSheetManager shouldForwardProp={shouldForwardProp}>
// so that styled() wrappers around custom components keep getting every prop, while DOM elements
// (string targets) only receive valid HTML attributes.
export const shouldForwardProp = (prop: string, target: unknown): boolean =>
  typeof target !== 'string' || isPropValid(prop);
